export default __webpack_public_path__ + "static/media/alert-light.eedda515.svg";